import React from 'react';
import type SandboxBundlerPageType from '@jira/spa-apps__sandbox-bundler/src/index.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { componentWithFG } from '@jira/platform__utils-feature-gates-gate-component/src/index.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { sandboxBundlerRoute } from '@jira/router-routes__sandbox-routes/src/sandboxBundlerRoute.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

const LazySandboxBundlerPage = lazyForPaint<typeof SandboxBundlerPageType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-sandbox-bundler", jiraSpaEntry: "async-sandbox-bundler" */ '@jira/spa-apps__sandbox-bundler/src/index.tsx'
		),
	),
);

const SandboxBundler = () => (
	<LazyPage Page={LazySandboxBundlerPage} pageId="sandbox-bundler" shouldShowSpinner />
);

export const sandboxBundlerRouteEntry: Route = createEntry(sandboxBundlerRoute, () => ({
	group: 'sandbox',
	// eslint-disable-next-line no-restricted-syntax
	component: componentWithFG('conditional_import_sandbox', SandboxBundler, ErrorPagesNotFound),
	layout: globalLayout,
	resources: [...getNavigationResources()],
	forPaint: [LazyAtlassianNavigation, LazySandboxBundlerPage],
	ufoName: 'sandbox-bundler',

	bifrost: {
		bifrostGroup: 'not-deployed',

		manifestName: 'jira-spa-sandboxdemo.json',
	},
}));
